import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined';
import SettingsOverscanIcon from '@material-ui/icons/SettingsOverscan';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import  PaymentIcon from '@material-ui/icons/Payment';
import {
    handleHelpDesk,
    handleScanReport, 
    handleLastStateStatistics, 
    handleEtaDeliveryRateReport, 
    handleUploadExcel,
    handlePostalCodesExportToolbar,
    handleLocalDeliveryCountReport,
    handleDriverEfficiencyManagement,
    handleMessageCenter,
    handleBbcOrderManagement,
} from '../../../reducers/uiSlice';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import PinDropIcon from '@material-ui/icons/PinDrop';
import { BlurLinear, CloudUpload, LocalShipping } from '@material-ui/icons';
import WidgetsIcon from '@material-ui/icons/Widgets';
import SendIcon from '@material-ui/icons/Send';
import LoopIcon from '@material-ui/icons/Loop';

const iconStyle = {
    fontSize: 32, 
    margin: 12
}

export const toolMenuItems = [
    {
        id:"menu-help-desk",
        dispatchFunction: handleHelpDesk(true),
        icon: <HelpOutlineOutlinedIcon style={iconStyle}/>,
        title: 'help_desk',
        access_ability_id: 19
    },{
        id:"menu-delivery-rate-report",
        dispatchFunction: handleEtaDeliveryRateReport(true),
        icon: <ContactsOutlinedIcon style={iconStyle}/>,
        title: 'eta_delivery_rate_report',
        access_ability_id: 20
    },{
        id:"menu-scan-report",
        dispatchFunction: handleScanReport(true),
        icon: <SettingsOverscanIcon style={iconStyle}/>,
        title: 'scan_report',
        access_ability_id: 22
    },{
        id:"menu-upload-excel",
        dispatchFunction: handleUploadExcel(true),
        icon: <CloudUpload style={iconStyle}/>,
        title: "upload_excel",
        access_ability_id: 23
    },{
        id:"menu-state-statistics",
        dispatchFunction: handleLastStateStatistics(true),
        icon: <BlurLinear style={iconStyle}/>,
        title: "last_state_statistics",
        access_ability_id: 24
    }
    // ,{
    //     id:"menu-local-delivery",
    //     link: "/local-delivery",
    //     icon: <LocalShipping style={iconStyle}/>,
    //     title: "local_delivery",
    //     access_ability_id: 25
    // }
    ,{
        id:"menu-export-postal-code",
        dispatchFunction: handlePostalCodesExportToolbar(true),
        icon: <PinDropIcon style={iconStyle}/>,
        title: 'postal_codes_export_toolbar',
        access_ability_id: 27
    },{
        id:"local-delivery-count-report",
        dispatchFunction: handleLocalDeliveryCountReport(true),
        icon: <WidgetsIcon style={iconStyle}/>,
        title: 'local-delivery-count-report',
        access_ability_id: 28
    },
    {
        id:"menu-driver-efficiency-management",
        link: "/driver-efficiency-management",
        icon: <ContactsOutlinedIcon style={iconStyle}/>,
        title: 'menu-driver-efficiency-management',
        access_ability_id: 35
    },
    {
        id:"menu-payroll-adjustment-management",
        link: "/payroll-adjustment-management",
        icon: <PaymentIcon style={iconStyle}/>,
        title: 'menu-payroll-adjustment-management',
        access_ability_id: 36
    },
    {
        id:"menu-message-center",
        dispatchFunction: handleMessageCenter(true),
        icon: <SendIcon style={iconStyle}/>,
        title: 'menu-message-center',
        access_ability_id: 39
    },
    {
        id: "self-pickup-tool",
        link: "/self-pickup-tool",
        icon: <DirectionsWalkIcon style={iconStyle} />,
        title: 'menu-self-pickup-tool',
        access_ability_id: 40
    },
    {
        id:"order-exchange-statistics",
        link: "/order-exchange-statistics",
        icon: <DataUsageIcon style={iconStyle}/>,
        title: 'order-exchange-statistics',
        access_ability_id: 41

    },
    {
        id: "bbc-order-management",
        dispatchFunction: handleBbcOrderManagement(true),
        icon: <LoopIcon style={iconStyle} />,
        title: 'bbc-order-management',
        access_ability_id: 44
    }
]
